import { Redirect } from "react-router-dom";
import { urls } from "./routes";
import { capturePages } from "./values";
import CasesRoutes from "../routes/CasesRoutes";

import {
  AddInjuryPage,
  AddPhysicalDamagePage,
  CaseDetailPage,
  CaseIncidents,
  CaseIncidentsSubmit,
  CaseLogPage,
  CaseMediaPage,
  CaseNotesPage,
  CasesPage,
  ContributorDetailPage,
  CreateCasePage,
  DownloadReportPage,
  EditInjuryPage,
  EditPhysicalDamagePage,
  InfoRequestsPage,
  InjuryDetailPage,
  InviteContributorsPage,
  LoginPage,
  MedicalRecordsPage,
  NotFoundPage,
  PhysicalDamageDetailPage,
  RedirectToAppStore,
  SettingsPage,
  ShareWithPage,
  StatementPage,
  StatementsPage,
  InterviewPage,
  ToolPage
} from "../containers";
import featureFlagKeys from "./featureFlagKeys";

const casesRoutes = [
  {
    isExact: true,
    Component: CreateCasePage,
    title: "createCase",
    id: "CreateCasePage",
    path: urls.createCase
  },
  {
    isExact: true,
    Component: ContributorDetailPage,
    title: "contributorDetails",
    id: "ContributorDetailPage",
    path: urls.contributorDetail
  },
  {
    isExact: true,
    Component: InfoRequestsPage,
    title: "infoRequests",
    id: "InfoRequestDetailPage",
    path: urls.infoRequestDetail
  },
  {
    Component: CaseNotesPage,
    title: "notes",
    id: "caseNotes",
    path: urls.caseNotes,
    featureFlag: featureFlagKeys.STATEMENTS
  },

  // Case Options Subroutes
  {
    isExact: true,
    Component: CaseLogPage,
    title: "caseLog",
    id: "caseLog",
    path: urls.caseLog
  },
  {
    Component: CaseIncidents,
    title: "caseIncidents",
    id: "CaseIncidents",
    path: urls.incident
  },
  {
    isExact: true,
    Component: CaseIncidentsSubmit,
    title: "caseIncidents",
    id: "CaseIncidentsSubmit",
    path: urls.submitIncident
  },
  {
    isExact: true,
    Component: ShareWithPage,
    title: "caseIncidents",
    id: "ShareWith",
    path: urls.shareWith
  },
  {
    Component: MedicalRecordsPage,
    title: "medicalRecords",
    id: "MedicalRecordsPage",
    path: urls.medicalRecords
  },
  {
    Component: CaseMediaPage,
    title: "media",
    id: "CaseMediaPage",
    path: urls.caseMedia
  },
  {
    isExact: true,
    Component: InfoRequestsPage,
    title: "infoRequests",
    id: "InfoRequestsPage",
    path: urls.infoRequests
  },
  {
    isExact: true,
    Component: InviteContributorsPage,
    title: "inviteContributors",
    id: "InviteContributorsPage",
    path: urls.inviteContributor
  },
  {
    isExact: true,
    Component: StatementPage,
    title: "newStatement",
    id: "StatementPage",
    path: urls.statement
  },
  {
    Component: StatementsPage,
    title: "statements",
    id: "StatementsPage",
    path: urls.statements
  },
  {
    isExact: true,
    Component: StatementPage,
    title: "statements",
    id: "interviewPage",
    path: urls.saiForm
  },
  {
    isExact: true,
    Component: InterviewPage,
    title: "statements",
    id: "sai",
    path: urls.sai
  },

  // Injuries
  {
    Component: EditInjuryPage,
    title: "editInjury",
    id: "EditInjuryPage",
    path: urls.editInjury
  },
  {
    Component: ToolPage,
    title: "annotationTool",
    id: "ToolPage",
    path: urls.annotationTool,
    props: { page: capturePages.INJURY }
  },
  {
    Component: AddInjuryPage,
    title: "addInjury",
    id: "AddInjuryPage",
    path: urls.addInjury
  },
  {
    Component: InjuryDetailPage,
    title: "injuryDetails",
    id: "InjuryDetailPage",
    path: urls.injuryDetail
  },

  // Physical Damage
  {
    Component: EditPhysicalDamagePage,
    title: "editPhysicalDamage",
    id: "EditPhysicalDamagePage",
    path: urls.editPhysicalDamage
  },
  {
    Component: AddPhysicalDamagePage,
    title: "addPhysicalDamage",
    id: "AddPhysicalDamagePage",
    path: urls.addPhysicalDamage
  },
  {
    Component: ToolPage,
    title: "annotationTool",
    id: "PhysicalDamageToolPage",
    path: urls.physicalDamageAnnotationTool,
    props: { page: capturePages.PHYSICAL_DAMAGE }
  },
  {
    Component: PhysicalDamageDetailPage,
    title: "physicalDamage",
    id: "PhysicalDamageDetailPage",
    path: urls.physicalDamageDetail
  },

  // Fallback Routes
  {
    Component: CaseDetailPage,
    title: "caseDetails",
    id: "CaseDetailPage",
    path: urls.caseDetail
  },
  {
    isExact: true,
    Component: CasesPage,
    id: "CasesPage",
    path: urls.cases
  }
];

export const publicRoutes = [
  {
    isExact: true,
    Component: RedirectToAppStore,
    title: "redirect",
    id: "appstores",
    path: urls.downloadApp
  },
  {
    isExact: true,
    Component: DownloadReportPage,
    title: "downloadReport",
    id: "DownloadReport",
    path: urls.downloadReport
  },
  {
    isExact: true,
    Component: NotFoundPage,
    title: "notFound",
    id: "NotFoundPage",
    path: urls.notFound
  },
  {
    isExact: true,
    Component: LoginPage,
    title: "login",
    id: "login",
    path: urls.login
  },
  {
    isExact: true,
    Component: Redirect,
    title: "logout",
    id: "logout",
    path: urls.logout,
    props: {
      to: urls.cases
    }
  }
];

export const privateRoutes = [
  {
    Component: CasesRoutes,
    id: "CasesPage",
    path: urls.cases,
    props: {
      routes: casesRoutes
    }
  },
  {
    isExact: true,
    Component: SettingsPage,
    title: "settings",
    id: "SettingsPage",
    path: urls.settings
  }
];
